import { render, staticRenderFns } from "./QuestionIncorrectRoute.vue?vue&type=template&id=24b9f7a0&scoped=true&"
import script from "./QuestionIncorrectRoute.vue?vue&type=script&lang=js&"
export * from "./QuestionIncorrectRoute.vue?vue&type=script&lang=js&"
import style0 from "./QuestionIncorrectRoute.vue?vue&type=style&index=0&id=24b9f7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9f7a0",
  null
  
)

export default component.exports